import React, { useCallback, useEffect, useState } from 'react';
import { Link, Navigate, useParams } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import api from '../services/api';
import { runningPath } from '../utils/paths';
import { normalizeClubSport } from '../config/clubSports';
import './RunningClubAdmin.css';

const RunningClubAdmin = () => {
  const { id } = useParams();
  const { user, isAdmin } = useAuth();
  const [club, setClub] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const [allowed, setAllowed] = useState(false);

  const load = useCallback(async () => {
    try {
      setLoading(true);
      const data = await api.getClubById(id);
      setClub(data);
      const isOwner = user?.id && data.adminUserId === user.id;
      setAllowed(!!(isOwner || isAdmin()));
    } catch (err) {
      setError(err.message || 'Failed to load club');
    } finally {
      setLoading(false);
    }
  }, [id, user?.id, isAdmin]);

  useEffect(() => {
    load();
  }, [load]);

  if (loading) return <div className="loading">Loading...</div>;
  if (error) return <div className="error-message">{error}</div>;
  if (!club) return <div className="error-message">Club not found</div>;
  if (normalizeClubSport(club.sport) !== 'RUNNING') {
    return <Navigate to={`/soccer/clubs/${id}/admin`} replace />;
  }
  if (!allowed) {
    return <Navigate to={runningPath(`/clubs/${id}`)} replace />;
  }

  return (
    <div className="running-club-admin">
      <p className="running-club-admin__eyebrow">
        <Link to={runningPath(`/clubs/${id}`)}>{club.name}</Link>
      </p>
      <h1>Club admin</h1>
      <p>Manage routes, group practices, and shareable team details.</p>

      <div className="running-club-admin__grid">
        <Link to={runningPath(`/clubs/${id}/routes`)} className="running-club-admin__card">
          <h2>Routes &amp; tracks</h2>
          <p>Create and publish practice routes with distance, surface, and map links.</p>
        </Link>
        <Link to={runningPath(`/clubs/${id}/practices`)} className="running-club-admin__card">
          <h2>Practices</h2>
          <p>Set gathering location, timing, and the route runners will select.</p>
        </Link>
        <Link to={runningPath(`/clubs/${id}`)} className="running-club-admin__card">
          <h2>Club home</h2>
          <p>Preview what runners see for upcoming practices and published routes.</p>
        </Link>
      </div>
    </div>
  );
};

export default RunningClubAdmin;
